export default __webpack_public_path__ + "static/media/thumbnail.cb1c604c.webp";